import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Checkbox } from '@wf-common/atoms'
import TagDropdown from '../tag-dropdown/tag-dropdown'
import { idPropType } from './props/id-prop-type'
import { itemSourcePropType } from './props/item-source-prop-type'

import styles from './tag-section-editor.module.css'

const propTypes = {
    itemSource: itemSourcePropType.isRequired,
    onChange: PropTypes.func,
    selectedItems: PropTypes.arrayOf(idPropType)
}

const defaultProps = {
    onChange: () => {},
    selectedItems: []
}

/**
 * This widget is part of <TagSectionEditor /> - see the docs there. It is not exposed to other outside use
 * Also see props.js for more info on the received propTypes
 */
function ItemSourceDropdown(props) {
    const { itemSource, onChange, selectedItems } = props

    const { className, filterPlaceholder, icon, id, items, placeholder, virtual } = itemSource
    const onSelect = event => {
        const selectedItems = event.target.value.map(itemId => ({
            itemId: itemId,
            sourceId: id
        }))

        onChange(selectedItems, id)
    }

    return (
        <TagDropdown
            className={cx(styles['dropdown'], className)}
            filterable
            groupTagsThreshold={2}
            name={`item-source-${id}`}
            onChange={onSelect}
            value={selectedItems}
            {...{ filterPlaceholder, icon, placeholder, virtual }}
        >
            {items.map((item, index) => {
                const { affix, icon, iconName, id, name } = item

                return (
                    <Checkbox affix={affix} key={index} icon={iconName} labelIcon={icon} value={id}>
                        {name}
                    </Checkbox>
                )
            })}
        </TagDropdown>
    )
}

ItemSourceDropdown.propTypes = propTypes
ItemSourceDropdown.defaultProps = defaultProps

export default ItemSourceDropdown
